export class CardToken {
	cardInfoKey: string = '';
	cardNumber: string = '';
	expirationDate: string = '';
	cardholderName: string = '';
	addressLine1: string = '';
	zipCode: string = '';
}
